import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { Clock, ShieldCheck, Lock } from 'lucide-react';
export function ValueSummary() {
  const {
    offerState,
    formattedTime,
    currentPrice,
    checkoutLink
  } = useCountdown();
  return <section className="bg-marron py-16 md:py-24 px-4 text-white" data-id="element-369">
      <div className="max-w-3xl mx-auto" data-id="element-370">
        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-10 backdrop-blur-sm" data-id="element-371">
          <h2 className="text-2xl md:text-3xl font-playfair font-bold text-center mb-8 text-crema" data-id="element-372">
            💰 RESUMEN DEL VALOR
          </h2>

          <div className="space-y-3 mb-8 text-sm md:text-base font-inter" data-id="element-373">
            <div className="flex justify-between items-center border-b border-white/10 pb-2" data-id="element-374">
              <span data-id="element-375">Manual Maestro Bio-Síntesis 3™</span>
              <span className="font-bold" data-id="element-376">$47</span>
            </div>
            <div className="flex justify-between items-center border-b border-white/10 pb-2" data-id="element-377">
              <span data-id="element-378">5 Desayunos Bio-Estimuladores</span>
              <span className="font-bold" data-id="element-379">$17</span>
            </div>
            <div className="flex justify-between items-center border-b border-white/10 pb-2" data-id="element-380">
              <span data-id="element-381">5 Almuerzos Anti-Glicación</span>
              <span className="font-bold" data-id="element-382">$17</span>
            </div>
            <div className="flex justify-between items-center border-b border-white/10 pb-2" data-id="element-383">
              <span data-id="element-384">5 Cenas Reparadoras de Dermis</span>
              <span className="font-bold" data-id="element-385">$17</span>
            </div>
            <div className="flex justify-between items-center border-b border-white/10 pb-2 text-terracota" data-id="element-386">
              <span data-id="element-387">🎁 6 Colaciones Rejuvenecedoras</span>
              <span className="font-bold" data-id="element-388">$27</span>
            </div>
            <div className="flex justify-between items-center border-b border-white/10 pb-2" data-id="element-389">
              <span data-id="element-390">Checklist de Superalimentos</span>
              <span className="font-bold" data-id="element-391">$9</span>
            </div>
            <div className="flex justify-between items-center border-b border-white/10 pb-2" data-id="element-392">
              <span data-id="element-393">Rastreador de 90 Días</span>
              <span className="font-bold" data-id="element-394">$9</span>
            </div>
            <div className="flex justify-between items-center pt-2 text-lg" data-id="element-395">
              <span className="font-bold text-crema" data-id="element-396">VALOR TOTAL</span>
              <span className="font-bold text-crema" data-id="element-397">$143</span>
            </div>
          </div>

          <div className="text-center bg-black/20 rounded-xl p-6 md:p-8 border border-terracota/30 relative overflow-hidden" data-id="element-398">
            {offerState === 'SECOND_CHANCE' && <div className="absolute top-0 left-0 w-full bg-rojo text-white text-xs font-bold py-1 uppercase tracking-wider" data-id="element-399">
                OFERTA INICIAL EXPIRADA - SEGUNDA OPORTUNIDAD ACTIVADA
              </div>}

            <div className="mt-4 flex flex-col items-center justify-center" data-id="element-400">
              <span className="text-gray-400 line-through text-xl mb-1" data-id="element-401">
                Valor Real: $143 USD
              </span>
              <span className="text-gray-400 line-through text-2xl mb-2" data-id="element-402">
                Precio Regular: $29 USD
              </span>

              {offerState === 'SECOND_CHANCE' && <span className="text-rojo/80 line-through text-3xl mb-2 font-playfair font-bold" data-id="element-403">
                  $6.39 USD
                </span>}

              {offerState === 'EXPIRED' && <>
                  <span className="text-rojo/80 line-through text-xl mb-1 font-playfair font-bold" data-id="element-404">
                    $6.39 USD
                  </span>
                  <span className="text-rojo/80 line-through text-2xl mb-2 font-playfair font-bold" data-id="element-405">
                    $9.99 USD
                  </span>
                </>}

              <div className="text-terracota text-5xl md:text-6xl font-playfair font-bold my-4 drop-shadow-lg" data-id="element-406">
                ${currentPrice} USD
              </div>

              {offerState === 'LAUNCH' && <div className="bg-rojo text-white px-4 py-2 rounded-full font-mono font-bold text-lg mb-6 flex items-center animate-pulse" data-id="element-407">
                  <Clock className="w-5 h-5 mr-2" data-id="element-408" />
                  EXPIRA EN: {formattedTime}
                </div>}

              {offerState === 'SECOND_CHANCE' && <div className="mt-2 mb-6 text-center" data-id="element-409">
                  <p className="text-sm text-crema/90 mb-3 max-w-md mx-auto" data-id="element-410">
                    Pero si estás aquí es porque esto te interesa, entonces te
                    activaré una segunda y última oferta especial a $9.99 USD,
                    pero solo por 5 minutos. ¡Cuidado! Una vez esto expira, el
                    precio vuelve a $29 USD y no tendrás oportunidad de
                    descuento.
                  </p>
                  <div className="bg-rojo text-white px-4 py-2 rounded-full font-mono font-bold text-xl inline-flex items-center animate-pulse" data-id="element-411">
                    <Clock className="w-6 h-6 mr-2" data-id="element-412" />
                    {formattedTime}
                  </div>
                </div>}

              <a href={checkoutLink} className="btn-primary w-full h-[64px] text-[16px] md:text-[18px] mb-4" data-id="element-413">
                ✅ ACCEDER AHORA POR ${currentPrice} USD →
              </a>

              <div className="flex items-center justify-center space-x-4 text-xs text-crema/60" data-id="element-414">
                <span className="flex items-center" data-id="element-415">
                  <Lock className="w-4 h-4 mr-1" data-id="element-416" /> Pago Seguro
                </span>
                <span className="flex items-center" data-id="element-417">
                  <ShieldCheck className="w-4 h-4 mr-1" data-id="element-418" /> Garantía 30 días
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}